import { createRoute, redirect } from "@tanstack/react-router";
import { safeRedirect } from "@/app/guards";
import { LoginPage } from "@/features/auth/LoginPage";
import { rootRoute } from "@/routes/root";

type LoginSearch = { redirect?: string };

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "login",
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    redirect: typeof search.redirect === "string" ? search.redirect : undefined,
  }),
  // Signing in changes the session, the router re-runs this, and the user leaves for their target.
  beforeLoad: ({ context, search }) => {
    if (context.session.me) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: LoginPage,
});
